import React, { memo } from 'react';
import { Box } from '@mui/material';
import { generateTimeSlots, getPixelsPerHour } from '../utils/timeUtils';
import { TimeScale } from '../types/calendar.types';

interface TimeSlotColumnProps {
  timeScale: TimeScale;
  showHeader?: boolean;
}

export const TimeSlotColumn: React.FC<TimeSlotColumnProps> = memo(({ 
  timeScale,
  showHeader = true,
}) => {
  const slots = generateTimeSlots(timeScale);
  const pixelsPerHour = getPixelsPerHour(timeScale);
  const slotHeight = pixelsPerHour / (60 / timeScale);

  return (
    <Box
      sx={{
        width: 80,
        flexShrink: 0,
        borderRight: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        position: 'sticky',
        left: 0,
        zIndex: 2,
      }}
    >
      {/* Header spacer - only show if showHeader is true */}
      {showHeader && (
        <Box
          sx={{
            height: 50,
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
          }}
        />
      )}
      
      {/* Time slots */}
      <Box sx={{ position: 'relative' }}>
        {slots.map((slot, index) => (
          <Box
            key={slot}
            sx={{
              height: slotHeight,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-end',
              pr: 1,
              borderBottom: index < slots.length - 1 ? '1px solid' : 'none',
              borderColor: 'divider',
              color: 'text.secondary',
              fontSize: '0.75rem',
              pt: 0.5,
              boxSizing: 'border-box',
            }}
          >
            {slot}
          </Box>
        ))}
      </Box>
    </Box>
  );
});

TimeSlotColumn.displayName = 'TimeSlotColumn';
